import { AxiosInstance } from 'axios';
import baseAxios, { fetchPaginatedDataFunction } from '@/helpers/forms/axios';
import { DataFetcherFunction } from '../../compiler/types';
import { ServiceProviderBillingStatus } from '../serviceProviderBilling';

export interface ChargebeeServiceProviderAccount {
    id: number
    name: string
    createdAt: string
    updatedAt: string
    serviceProviderId: number
    chargebeeAccountId: string
    subscriptionIds: string[]
    subscriptionsCount: number
}

export default (axios: AxiosInstance = baseAxios): { fetchChargebeeAccounts: DataFetcherFunction<ChargebeeServiceProviderAccount>; createChargebeeAccountLink: (serviceProviderId: number, chargebeeAccountId: string) => Promise<void>; pullSubscriptions: (chargebeeAccountId: string) => Promise<void>; getAccountStatus: (serviceProviderId: number) => Promise<ServiceProviderBillingStatus>; } => ({
    fetchChargebeeAccounts: fetchPaginatedDataFunction<ChargebeeServiceProviderAccount>(
        '/api/admin/service-provider-billing/chargebee/accounts',
        undefined,
        axios,
    ),

    createChargebeeAccountLink: async (serviceProviderId: number, chargebeeAccountId: string): Promise<void> => {
        return await axios.post('/api/admin/service-provider-billing/chargebee/accounts', {
            serviceProviderId,
            chargebeeAccountId,
        });
    },

    pullSubscriptions: async (chargebeeAccountId: string): Promise<void> => {
        return await axios.post('/api/admin/service-provider-billing/chargebee/pull-subscriptions', {
            chargebee_account_id: chargebeeAccountId,
        });
    },

    getAccountStatus: async (serviceProviderId: number): Promise<ServiceProviderBillingStatus> => {
        const response = await axios.get<ServiceProviderBillingStatus>(`/api/admin/service-provider-billing/status?service_provider_id=${serviceProviderId}`);

        return response.data;
    },
});
